import React from 'react';
import { CompositeView, GridView, SimpleView } from '@digital/ui';
import AbaPendente from './AbaPendente';
import AbaConcluido from './AbaConcluido';

const PreSuprimentosSuprimentos = () => {
  return (
    <SimpleView>
      <CompositeView>
        <GridView title="pendente" icon="ui-in_progress" id="pendentes" noform>
          <AbaPendente />
        </GridView>
        <GridView title="concluído" icon="ui-offline_pin" id="concluidos" noform>
          <AbaConcluido />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};

export default PreSuprimentosSuprimentos;
